// extracted by mini-css-extract-plugin
export default {"containerClass":"InputNumberFieldV2__containerClass___Xyj4a","errorClass":"InputNumberFieldV2__errorClass___oyvp4"};